import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Head from './Head';
import Header from './Header';
import Footer from './Footer'; // Footer'ı da ekliyoruz
import Home from './pages/Home';
import AboutPage from './pages/AboutPage'; // AboutPage'yi ekliyoruz
import Preloader from './components/Preloader';

const App = () => {
  return (
    <Router>
      <Head />
      <Preloader />
      <div className="page-wrapper">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hakkimizda" element={<AboutPage />} /> {/* İçerik buraya gelecek */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
